import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { Customer, Coupon, CartItem, LiveOrder, OrderContext, MenuType } from '../../types';

interface AppState {
    customer: Customer | null;
    setCustomer: (customer: Customer | null) => void;
    activeCoupon: Coupon | null;
    setActiveCoupon: (coupon: Coupon | null) => void;
    cart: CartItem[];
    setCart: (cart: CartItem[] | ((prev: CartItem[]) => CartItem[])) => void;
    orderHistory: LiveOrder[];
    setOrderHistory: (history: LiveOrder[]) => void;
    // UI state
    isOrderModalOpen: boolean;
    setOrderModalOpen: (isOpen: boolean) => void;
}

export const useAppStore = create<AppState>()(
    persist(
        (set) => ({
            customer: null,
            setCustomer: (customer) => set({ customer }),
            activeCoupon: null,
            setActiveCoupon: (coupon) => set({ activeCoupon: coupon }),
            cart: [],
            setCart: (cartOrUpdater) => set((state) => ({
                cart: typeof cartOrUpdater === 'function' ? cartOrUpdater(state.cart) : cartOrUpdater
            })),
            orderHistory: [],
            setOrderHistory: (orderHistory) => set({ orderHistory }),
            isOrderModalOpen: false,
            setOrderModalOpen: (isOrderModalOpen) => set({ isOrderModalOpen }),
        }),
        {
            name: 'app-storage',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({ cart: state.cart }),
        }
    )
);

